import React, { Component, Fragment } from 'react'
import {
  Grid,
  ListItem,
  withStyles,
  Hidden,
  Typography,
  IconButton,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import styles from '../../styles'
import ToggleViewButton from '../ToggleViewButton'
// import RightButtons from './RightButtons'
import PanelsAndResponses from './PanelsAndResponses'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { read } from 'actions/data'
import classNames from 'classnames'
import ChartsContainer from './ChartsContainer'
import language from 'utils/vast-languagepack'
import { toggleDialog } from 'actions/view'

export class IndividualResponseComponent extends Component {
  render() {
    const {
      contactName,
      contactMethod,
      response,
      sectionsByID,
      classes,
      inbox,
      contactID,
      toggleDialog,
      close,
    } = this.props

    const answers = {
      ...(response?.contact_fields || {}),
      ...(response?.custom_fields || {}),
    }

    // console.log(answers)

    const questionsAndAnswers = (
      <div className={classes.questionsAndAnswers}>
        {
          /* (inbox || contactName || contactMethod) && */
          Object.keys(answers).map(field_name => {
            const section = sectionsByID?.[field_name]
            const fieldOrContactField = section?.field || section?.contactfield

            if (
              answers?.[field_name] !== null &&
              answers?.[field_name]?.toString?.() !== ''
            ) {
              return (
                <div
                  style={{
                    paddingBottom: 20,
                    borderRight: '1px solid #e0e0e0',
                  }}
                  key={`${field_name}QuestionAndAnswerAnalyze`}
                >
                  <div style={{ padding: '0 20px' }}>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: '18.72px',
                        padding: '2px',
                      }}
                    >
                      {section?.label || field_name || 'Unknown'}
                      {fieldOrContactField?.required && (
                        <span style={{ color: 'red' }}>*</span>
                      )}
                    </h3>
                    {section?.description && (
                      <div
                        style={{
                          fontSize: '12.72px',
                          marginTop: '-5px',
                          padding: 2,
                        }}
                      >
                        {section?.description}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      padding: '0 20px',
                      backgroundColor: '#d9d9da',
                    }}
                  >
                    {Array.isArray(answers?.[field_name])
                      ? answers?.[field_name]?.join?.(', ')
                      : answers?.[field_name]}
                  </div>
                </div>
              )
            }

            return null
          })
        }
      </div>
    )

    if (inbox) {
      return questionsAndAnswers
    }

    return (
      <div
        style={{
          height: '100%',
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >
        <div
          onClick={
            contactID && contactID !== '-1'
              ? () =>
                  toggleDialog({
                    open: true,
                    dialog: 'contact',
                    options: { contactID },
                  })
              : () => {}
          }
          style={{
            height: 54,
            backgroundColor: '#15b940',
            color: '#fff',
            position: 'relative',
            fontSize: 17,
            fontWeight: 'bold',
            textAlign: 'center',
            paddingTop: 5,
            borderTop: '1px solid gray',
            borderRight: '1px solid gray',
            borderLeft: '1px solid gray',
            cursor: contactID ? 'pointer' : undefined,
          }}
        >
          <IconButton
            style={{
              position: 'absolute',
              right: 5,
              top: 5,
              padding: 5,
              color: '#fff',
            }}
            onClick={e => {
              e.stopPropagation()
              close()
            }}
          >
            <Close />
          </IconButton>
          {contactName && <div>{contactName}</div>}
          {contactMethod && <div>{contactMethod}</div>}
          {contactName || contactMethod
            ? null
            : 'Click a response to view its answers'}
        </div>
        {questionsAndAnswers}
      </div>
    )
  }
}

const IndividualResponse = connect(
  (state, { responseSelected }) => ({
    response: state.data?.['customform/entry']?.[responseSelected],
    sectionsByID: state.customForm.addOrEdit.sectionsByID,
  }),
  dispatch => bindActionCreators({ toggleDialog }, dispatch),
)(IndividualResponseComponent)

class ResponseView extends Component {
  state = {
    responseSelected: null,
    singleResDisplayed: false,
    contactName: '',
    contactMethod: '',
  }

  componentDidMount() {
    const { read, formID } = this.props

    if (formID !== 'new' && this.props.formTypeSelected !== 'signup') {
      read(formID, 'customFormEntries', 'customform/entry', 'form_id')
    }
    // .then((res) =>
    // 	this.setState({
    // 		responseSelected: res?.submits?.[0]?.subresource_uri?.slice(18),
    // 	}),
    // )
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.formID !== 'new' &&
      prevProps.formID !== this.props.formID &&
      this.props.formTypeSelected !== 'signup'
    ) {
      this.props.read(
        this.props.formID,
        'customFormEntries',
        'customform/entry',
        'form_id',
      )
    }
  }

  render() {
    const { classes, viewSelected, submits, read } = this.props

    const label = submit => {
      if (submit?.contact_name) {
        return `${submit?.contact_name}${
          submit?.contact_method ? ` (${submit?.contact_method})` : ''
        }`
      }

      if (submit?.contact_method) {
        return submit?.contact_method
      }

      return 'Anonymous'
    }

    const listItemOnClick = (submit, changeView) => {
      this.setState({
        contactID: submit?.contact_id,
        contactName: submit?.contact_name || '',
        contactMethod: submit?.contact_method || '',
        responseViewOpen: true,
      })

      read(
        submit?.subresource_uri?.slice(18),
        'customform/entry',
        null,
        null,
        'object',
        submit?.subresource_uri?.slice(18),
      ).then(() =>
        this.setState({
          responseSelected: submit?.subresource_uri?.slice(18),
          singleResDisplayed: Boolean(changeView),
        }),
      )
    }

    const listItem = submit => (
      <Fragment key={submit.subresource_uri}>
        <Hidden mdUp>
          <ListItem
            style={
              this.state?.contactID === submit?.contact_id
                ? { backgroundColor: 'rgba(0, 0, 0, 0.08)' }
                : null
            }
            className={classNames(classes.panel, 'contact-expansion-panel')}
            button
            onClick={() => listItemOnClick(submit, true)}
            classes={{
              container: classes.container,
            }}
          >
            <div className={classes.panelContent}>
              <div className={classes.textWrapper}>
                <span className={classes.text}>
                  <strong>{label(submit)}</strong>
                  <br />
                  {typeof submit?.timestamp === 'number'
                    ? new Date(submit?.timestamp * 1000).toLocaleString()
                    : ''}
                </span>
              </div>
            </div>
          </ListItem>
        </Hidden>
        <Hidden smDown>
          <ListItem
            style={
              this.state?.contactID === submit?.contact_id
                ? { backgroundColor: 'rgba(0, 0, 0, 0.08)' }
                : null
            }
            className={classNames(classes.panel, 'contact-expansion-panel')}
            button
            onClick={() => listItemOnClick(submit)}
            classes={{
              container: classes.container,
            }}
          >
            <div className={classes.panelContent}>
              <div className={classes.textWrapper}>
                <span className={classes.text}>
                  <strong>{label(submit)}</strong> -{' '}
                  {typeof submit?.timestamp === 'number'
                    ? new Date(submit?.timestamp * 1000).toLocaleString()
                    : ''}
                </span>
              </div>
            </div>
          </ListItem>
        </Hidden>
      </Fragment>
    )

    // return <div>hello world</div>
    return (
      <>
        <Grid
          style={{ height: '100%' }}
          className={classes.main}
          container
          spacing={24}
        >
          {/* <Grid item xs={12}>
		     <RightButtons />
		    </Grid> */}
          <Grid
            item
            xs="12"
            sm="12"
            md={
              viewSelected === 'response'
                ? '12'
                : this.state.contactMethod
                ? '8'
                : '12'
            }
          >
            <div style={{ textAlign: 'left' }}>
              <ToggleViewButton
                singleResDisplayed={this.state.singleResDisplayed}
                goBack={() => this.setState({ singleResDisplayed: false })}
              />
            </div>
            {!this.state.singleResDisplayed && viewSelected === 'preview' && (
              <PanelsAndResponses />
            )}
            {viewSelected === 'response' && (
              <div style={{ marginTop: 20 }}>
                <ChartsContainer />
              </div>
            )}
            {viewSelected === 'preview' ? (
              this.state.singleResDisplayed ? (
                <div style={{ marginTop: 18 }}>
                  <IndividualResponse
                    close={() =>
                      this.setState({
                        responseViewOpen: false,
                        contactName: '',
                        contactMethod: '',
                        responseSelected: null,
                        singleResDisplayed: false,
                      })
                    }
                    contactName={this.state.contactName}
                    contactMethod={this.state.contactMethod}
                    responseSelected={this.state.responseSelected}
                    classes={classes}
                    contactID={this.state.contactID}
                  />
                </div>
              ) : (
                <>
                  <div
                    style={
                      this.props.formTypeSelected === 'customIntegration'
                        ? { marginTop: 10 }
                        : null
                    }
                  >
                    {submits?.length ? (
                      <div
                        style={{ backgroundColor: '#fff' }}
                        className={classes.responseList}
                      >
                        {submits?.map(submit => listItem(submit)) || null}
                      </div>
                    ) : this.props.formTypeSelected === 'signup' ? null : (
                      <Typography variant="h4" gutterBottom>
                        {language.signupform.add.responses.noResponses}
                      </Typography>
                    )}
                  </div>
                </>
              )
            ) : null}
          </Grid>
          {viewSelected === 'preview' && this.state.responseViewOpen && (
            <Hidden smDown>
              <Grid item xs="12" sm="12" md="4">
                <IndividualResponse
                  close={() =>
                    this.setState({
                      responseViewOpen: false,
                      contactName: '',
                      contactMethod: '',
                      responseSelected: null,
                      singleResDisplayed: false,
                    })
                  }
                  contactName={this.state.contactName}
                  contactMethod={this.state.contactMethod}
                  responseSelected={this.state.responseSelected}
                  classes={classes}
                  contactID={this.state.contactID}
                />
              </Grid>
            </Hidden>
          )}
        </Grid>
      </>
    )
  }
}

export default connect(
  state => {
    const formID =
      state.signupForm.addOrEdit.formID || state.customForm.addOrEdit?.id

    return {
      formID,
      viewSelected: state.signupForm.addOrEdit.previewResponseView,
      submits: state.data?.customFormEntries?.[formID]?.submits,
      formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
      sections: state.customForm.addOrEdit?.form?.sections?.map(
        sectionID => state.customForm.addOrEdit?.sectionsByID?.[sectionID],
      ),
    }
  },
  dispatch => bindActionCreators({ read }, dispatch),
)(withStyles(styles)(ResponseView))
